module.exports = __webpack_public_path__ + "static/icons/icon-caret-down--white-0eb22ab9c2413d9109e2bda2c39243ec.svg";